import React from 'react';
import { ContactCta, Disclosure, splitTextPaddingClass } from './ui';
import Picture from './Picture';

const IMAGE = {
  src: '/images/Flugsportverein_Bilder_3.jpg',
  alt: 'Baumkronenpfad im Nationalpark Hainich aus der Luft',
};

const Introduction: React.FC = () => {
  return (
    <section id="ueber-uns" className="mt-6 border-t-2 border-gray-900 lg:mt-0 lg:grid lg:grid-cols-2">
      <div className={`${splitTextPaddingClass} pb-10 pt-12 lg:flex lg:flex-col lg:justify-between lg:gap-10 lg:py-16`}>
        <div>
          <h2 className="mb-3.5 text-[34px] font-extrabold leading-[1.04] tracking-[-0.02em] lg:mb-4 lg:text-[56px] lg:leading-none lg:tracking-[-0.025em]">
            Vor den Toren des <br className="hidden lg:block" />
            <span className="text-blue-600">Nationalparks Hainich</span>
          </h2>
          <p className="mb-6 text-lg font-medium text-gray-600 lg:mb-8 lg:text-xl">In Bad Langensalza Zuhause</p>

          <div className="mb-5 aspect-[4/3] overflow-hidden lg:hidden">
            {/* 16:9 in 4:3 geschnitten – braucht ca. 1,33-fache Breite */}
            <Picture src={IMAGE.src} alt={IMAGE.alt} sizes="134vw" className="block h-full w-full object-cover" />
          </div>

          <div className="grid grid-cols-2 border-b border-t-2 border-b-gray-200 border-t-gray-900 lg:max-w-[440px]">
            <div className="border-r border-gray-200 py-4 pr-3 lg:py-[18px] lg:pr-4">
              <p className="text-[30px] font-extrabold leading-none tracking-[-0.02em] lg:text-4xl">Fast 100</p>
              <p className="mt-1.5 text-[13px] text-gray-600 lg:text-sm">Mitglieder</p>
            </div>
            <div className="py-4 pl-3.5 lg:py-[18px] lg:pl-[18px]">
              <p className="text-[30px] font-extrabold leading-none tracking-[-0.02em] text-blue-600 lg:text-4xl">eine</p>
              <p className="mt-1.5 text-[13px] text-gray-600 lg:text-sm">Leidenschaft</p>
            </div>
          </div>
        </div>

        <div className="mt-5 lg:mt-0">
          <Disclosure
            id="geschichte"
            title="Mehr über unsere Geschichte"
            buttonClassName="border-b border-gray-200 lg:border-t"
            panelClassName="flex flex-col gap-3 pb-1 pt-[18px] text-[15px] leading-[1.55] text-gray-700 lg:gap-2.5"
          >
            <h4 className="text-base font-semibold text-gray-900 lg:text-[15px]">Die Anfänge des Flugplatzes (1927-1945)</h4>
            <p>
              Die Geschichte unseres Flugplatzes reicht weit zurück: Bereits 1927 wurde der Flugplatz Langensalza errichtet. Im Zuge der Aufrüstung der Wehrmacht baute die Luftwaffe das Gelände in den Jahren 1937/38 erheblich aus. Hier wurden DFS 230-Lastensegler getestet und verschiedene militärische Einheiten stationiert.
            </p>
            <p>
              Von 1940 bis 1945 war der Fliegerhorst Heimat für Sturzkampfbombereinheiten, Nachtjäger vom Typ Ju 88-G6 sowie größere Ausbildungseinheiten. Besonders bedeutsam waren die hier stationierten Geschwader wie das II./St.G. 163, III./St.G. 2 und I./NJG 2. Am 7. April 1945 wurde der Fliegerhorst durch eine Panzerdivision der US Army besetzt und bis Juli 1945 als Advanced Landing Ground ALG R-2 genutzt.
            </p>

            <h4 className="mt-2 text-base font-semibold text-gray-900 lg:mt-1.5 lg:text-[15px]">DDR-Zeit und zivile Nutzung</h4>
            <p>
              Nach dem Krieg erfolgte zunächst die totale Demontage der militärischen Anlagen. Über viele Jahre in der DDR wurde das Gelände des ehemaligen "Fliegerhorstes" als Agrarflugplatz genutzt. Hier flog zeitweise auch die legendäre AN-2, und sowohl Segelflug der GST als auch Modellflug im Rahmen einer Arbeitsgemeinschaft fanden hier statt.
            </p>
            <p>
              Unser Flugsportverein war schon zu DDR-Zeiten der Anlaufpunkt für Kinder, Jugendliche und jung gebliebene Erwachsene, die ihre Leidenschaft für die Fliegerei entdeckten.
            </p>

            <h4 className="mt-2 text-base font-semibold text-gray-900 lg:mt-1.5 lg:text-[15px]">Neubeginn nach der Wende</h4>
            <p>
              Die Gründung des Vereins unter seinem jetzigen Namen erfolgte 1990, so dass wir 2010 unser 20-jähriges Bestehen feiern konnten. Mit viel Elan, Ausdauer, Einfallsreichtum und Enthusiasmus haben unsere Mitglieder des Flugsportvereins Bad Langensalza ein modernes Fluggelände geschaffen, welches sich sehen lassen kann!
            </p>
            <p>
              Heute ist der Flugplatz Langensalza (ICAO-Code: EDEB) als Sonderlandeplatz klassifiziert. Im Norden ist landwirtschaftlich genutzte Fläche, im Süden starten und landen die Segel- und Motorflugzeuge.
            </p>
          </Disclosure>

          <ContactCta className="mt-6 lg:mt-7">Interesse geweckt? Kontaktieren Sie uns für einen Gastflug!</ContactCta>
        </div>
      </div>

      <div className="relative hidden min-h-[640px] border-l border-gray-200 lg:block">
        {/* Querformat füllt die hohe rechte Hälfte über die Höhe – daher breiter als 50vw */}
        <Picture src={IMAGE.src} alt={IMAGE.alt} sizes="1400px" className="absolute inset-0 h-full w-full object-cover" />
      </div>
    </section>
  );
};

export default Introduction;
